import { render } from "./CloseOrderModal.vue?vue&type=template&id=6bf14f20&scoped=true"
import script from "./CloseOrderModal.vue?vue&type=script&lang=js"
export * from "./CloseOrderModal.vue?vue&type=script&lang=js"

import "./CloseOrderModal.vue?vue&type=style&index=0&id=6bf14f20&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf14f20"]])

export default __exports__